import { render, staticRenderFns } from "./role.vue?vue&type=template&id=3a79279d&scoped=true"
import script from "./role.vue?vue&type=script&lang=js"
export * from "./role.vue?vue&type=script&lang=js"
import style0 from "./role.vue?vue&type=style&index=0&id=3a79279d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a79279d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\abroad-hrms-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a79279d')) {
      api.createRecord('3a79279d', component.options)
    } else {
      api.reload('3a79279d', component.options)
    }
    module.hot.accept("./role.vue?vue&type=template&id=3a79279d&scoped=true", function () {
      api.rerender('3a79279d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/organization/newAccount/role.vue"
export default component.exports